module.exports = __webpack_public_path__ + "img/login.0cf4c227.png";